export default __webpack_public_path__ + "static/media/aboutme.829627bb.png";